import React, { useRef, useEffect } from 'react'

export interface RegistrationListHeaderProps {
  areActionsHidden: boolean
  showCheckbox?: boolean
  allChecked?: boolean
  someChecked?: boolean
  onCheckedAllChange?: (checked: boolean) => void
}

export const RegistrationListHeader: React.FC<RegistrationListHeaderProps> = (props) => {
  const checkboxRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = props.someChecked ?? false
    }
  }, [props.someChecked])

  return (
    <>
      <tr>
        {props.showCheckbox && (
          <th scope="col" className="w-10 px-3 py-3">
            <input
              ref={checkboxRef}
              type="checkbox"
              className="h-4 w-4 rounded border-slate-300 dark:border-slate-600 text-indigo-600 focus:ring-indigo-600 cursor-pointer"
              checked={props.allChecked ?? false}
              onChange={(e) => props.onCheckedAllChange?.(e.target.checked)}
            />
          </th>
        )}
        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider">
          Tenant name
        </th>
        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider" colSpan={props.areActionsHidden ? 3 : 1}>
          Contact
        </th>
        {!props.areActionsHidden && (
          <>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider">
              Status
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider">
              <span className="sr-only">Actions</span>
            </th>
          </>
        )}
      </tr>
    </>
  )
}

export default RegistrationListHeader
